/**
 * cấp ngân sách
 * nddung2 17.07.2024
 */
export default {
  AllDistrict: 0, // toàn huyện
  District: 3, // cấp huyện
  Ward: 4, // cấp xã
};